if (!customElements.get('shipping-availability')) {
  customElements.define(
    'shipping-availability',
    class extends HTMLElement {
      connectedCallback() {
        const cfgEl = this.querySelector('[data-shipping-config]');
        const target = this.querySelector('[data-shipping-text]');
        if (!cfgEl || !target) return;

        let cfg;
        try {
          cfg = JSON.parse(cfgEl.textContent);
        } catch (e) {
          return;
        }

        // 発送日数目安（custom.shipping_lead_time）が最優先。
        // 「10〜12営業日」なら期間、「14営業日」なら単日、数値が無ければ文言をそのまま出す。
        const leadText = (cfg.leadTimeText || '').trim();
        const leadRange = leadText.match(/(\d+)\s*[〜~～ー−-]\s*(\d+)\s*営業日/);
        const leadOne = leadRange ? null : leadText.match(/(\d+)\s*営業日/);

        let minDays = Math.max(0, parseInt(cfg.businessDaysMin, 10) || 0);
        const rawMax = parseInt(cfg.businessDaysMax, 10);
        let maxDays = Number.isFinite(rawMax) ? Math.max(minDays, rawMax) : minDays;
        if (leadRange) {
          minDays = parseInt(leadRange[1], 10);
          maxDays = Math.max(minDays, parseInt(leadRange[2], 10));
        } else if (leadOne) {
          minDays = maxDays = parseInt(leadOne[1], 10);
        }

        // 目安のテキストはあるが営業日の数値が読めない商品（「メーカー手配後約2週間程度」等）は
        // 日付に換算できないので、入力された文言だけを出す。
        if (leadText && !leadRange && !leadOne) {
          target.textContent = '';
          const only = document.createElement('span');
          only.className = 'shipping-availability__lead';
          only.textContent = leadText;
          target.appendChild(only);
          return;
        }

        const weeklyClosed = new Set(cfg.weeklyClosed || []);
        const blockedDates = new Set();
        (cfg.exceptions || []).forEach((ex) => {
          // Both holiday and shipping_only block production progress
          // (per Epic #116 spec: shipping_only halts manufacturing)
          if (ex.type === 'holiday' || ex.type === 'shipping_only') {
            blockedDates.add(ex.date);
          }
        });

        const weekdays = [
          'sunday',
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
        ];

        const todayKey = cfg.todayHint || ymd(new Date());
        const [ty, tm, td] = todayKey.split('-').map(Number);

        // Walk forward from today, recording the date after the Nth business day for N=1..maxDays
        const dateForDay = new Array(maxDays + 1);
        dateForDay[0] = new Date(ty, tm - 1, td);
        let cursor = new Date(ty, tm - 1, td);
        let remaining = maxDays;
        let counted = 0;
        let safety = 365;
        while (remaining > 0 && safety-- > 0) {
          cursor.setDate(cursor.getDate() + 1);
          const key = ymd(cursor);
          const wd = weekdays[cursor.getDay()];
          if (weeklyClosed.has(wd)) continue;
          if (blockedDates.has(key)) continue;
          counted++;
          dateForDay[counted] = new Date(cursor);
          remaining--;
        }

        const minDate = dateForDay[minDays] || cursor;
        const maxDate = dateForDay[maxDays] || cursor;
        const labels = cfg.weekdayLabels || ['日', '月', '火', '水', '木', '金', '土'];

        // 単日・期間とも月日を「9/16」の形式に統一する（Issue #740）。
        function fmt(d) {
          return `${d.getMonth() + 1}/${d.getDate()}`;
        }

        const isRange = maxDays > minDays;
        // 期間で出すときは両端の曜日まで入れる（「9/16（水）〜9/18（金）」）。
        // {weekday} は単日のときだけ使う。
        const dateLabel = isRange
          ? `${fmt(minDate)}（${labels[minDate.getDay()]}）〜${fmt(maxDate)}（${labels[maxDate.getDay()]}）`
          : fmt(minDate);
        const weekdayLabel = labels[(isRange ? maxDate : minDate).getDay()];

        const template = isRange
          ? cfg.templateRange || '{date}'
          : cfg.template || '{date}（{weekday}）以降発送可能';
        const html = template
          .replace('{date}', `<strong data-emphasize>${dateLabel}</strong>`)
          .replace('{weekday}', weekdayLabel);

        // 日付に換算できたときは日付だけを出す。営業日の文言（「3〜20営業日」等）は
        // 日付と同じことを二度言うだけなので出さない。
        target.innerHTML = `<span class="shipping-availability__dates">${html}</span>`;
        this.dataset.shipDateMin = ymd(minDate);
        this.dataset.shipDateMax = ymd(maxDate);

        function ymd(d) {
          const y = d.getFullYear();
          const mo = String(d.getMonth() + 1).padStart(2, '0');
          const da = String(d.getDate()).padStart(2, '0');
          return `${y}-${mo}-${da}`;
        }
      }
    }
  );
}
